export const UPDATE_ALL_EVENT = "update-all-event";
export const UPDATE_EVENT = "update-event";
export const DELETE_EVENT = "delete-event";
export const CREATE_EVENT = "create-event";

export const CLIENT_UPDATE_EVENT = "client-update-event";
